"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollectionStateEnum = void 0;
var CollectionStateEnum;
(function (CollectionStateEnum) {
  /** Находится в черновиках */
  CollectionStateEnum["draft"] = "draft";
  /** Отправлена в архив */
  CollectionStateEnum["archived"] = "archived";
  /** Находится на модерации */
  CollectionStateEnum["on_moderation"] = "on_moderation";
  /** Одобрена при модерации */
  CollectionStateEnum["approved"] = "approved";
  /** Отклонена при модерации */
  CollectionStateEnum["declined"] = "declined";
})(CollectionStateEnum = exports.CollectionStateEnum || (exports.CollectionStateEnum = {}));
